import '../../../../utils/string/string-prototype.utils';
import {FormEntity} from '../../../content/shared/entities/FormEntity';

/**
 * Used to hold the getter and setter for the Id parameter for other entities
 * @class AbstractEntity
 * @abstract
 */
export abstract class AbstractEntity {
  /**
   * The id of the entity
   * @protected
   * @type {string}
   */
  protected id: string;

  /**
   * @constructor
   * @param {object} data the data for the entity to hydrate from
   * @param {string} id - The id of the entity
   */
  constructor({data, id = null}: {data: any, id?: string}) {
    this.update(data);
    this.setId(id);
  }

  /**
   * update object data
   * @param {object} data to update entity with
   *
   * @returns {void}
   */
  update(data: object): void {
    for (const prop in data) {
      if (`set${prop.capitalizeFirstLetter(false)}` in this) {
        this[`set${prop.capitalizeFirstLetter(false)}`](data[prop]);
      }
    }
  }

  /**
   * Getter for the id
   * @returns {string}
   */
  getId(): string {
    return this.id;
  }

  /**
   * Setter for the id
   * @param {string} value - value to set the id
   * @return {AbstractEntity}
   */
  setId(value: string): AbstractEntity {
    this.id = value;

    return this;
  }

  /**
   * Iterates through the passed in data and updates
   * @param {object} data form data from the valueChanges function
   * @returns {void}
   */
  updateValues(data): void {
    for (const prop in data) {
      if (`set${prop.ucWords()}` in this) {
        const capitalizedProp = prop.capitalizeFirstLetter(),
          fn = this[`get${capitalizedProp}`]();
        if (fn instanceof FormEntity) {
          fn.setValue(data[prop]);
        }
        else {
          this[`set${capitalizedProp}`](data[prop]);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/entities/abstract/abstract.entity.ts